import React, { useEffect, useState } from 'react';
import { Box, FormControl } from '@mui/material';
import Select, { SingleValue } from 'react-select';

type organizationUserOptionEntry = { value: string; label: string };

interface SingleValueInputProps {
  label: string;
  data: any[];
  minDataCount?: number;
  value: any;
  onChange: (e: any) => void;
  isDisabled?: boolean;
  placeholder?: string;
}

export const SingleValueInput = (props: SingleValueInputProps) => {
  const [selectedOption, setSelectedOption] = useState<SingleValue<organizationUserOptionEntry>>(null);

  // Build options array
  const options: organizationUserOptionEntry[] = [];
  if (Array.isArray(props.data) && props.data.length > 0) {
    // Check if data contains objects with accountId and publicName
    if (typeof props.data[0] === 'object' && props.data[0] !== null && 'accountId' in props.data[0]) {
      props.data.forEach((entry: any) => {
        if (entry.accountId && entry.publicName) {
          options.push({ value: entry.accountId, label: entry.publicName });
        }
      });
    } else if (typeof props.data[0] === 'string') {
      // Fallback for string array
      (props.data as string[]).forEach(entry => {
        if (entry) {
          options.push({ value: entry, label: entry });
        }
      });
    }
  }

  // Update selected option when value or data changes
  useEffect(() => {
    if (!props.value) {
      setSelectedOption(null);
      return;
    }

    // Find the option that matches the current value
    const matchedOption = options.find(opt => opt.value === props.value);

    if (matchedOption) {
      setSelectedOption(matchedOption);
    } else if (props.value) {
      // If we have a value but no match yet (e.g., data still loading), create a temporary option
      setSelectedOption({ value: props.value, label: props.value });
    }
  }, [props.value, props.data]);

  function handleSelect(eventData: SingleValue<organizationUserOptionEntry>) {
    setSelectedOption(eventData);
    if (eventData) {
      props.onChange(eventData.value);
    } else {
      props.onChange('');
    }
  }

  return (
    <FormControl sx={{ flex: 1 }}>
      <Box sx={{ m: 2 }}>
        <div className="dropdown-container">
          <h2>{props.label}</h2>
          <Select
            options={options}
            isDisabled={props.isDisabled}
            placeholder={props.placeholder}
            value={selectedOption}
            onChange={handleSelect}
            isSearchable
            isMulti={false}
            isClearable
          />
        </div>
      </Box>
    </FormControl>
  );
};
